import { Outlet } from 'react-router-dom';
import {Suspense} from "react";
import LoadingPage from "../../pages/error-pages/LoadingPage";
import ChunkErrorBoundary from '../../components/ChunkErrorBoundary.jsx';

import './PublicLayout.css';

const RegistrationLayout = () => {
    return (
        <div className="home-page">
            <>
                <ChunkErrorBoundary>
                    <Suspense fallback={<LoadingPage />}>
                        <Outlet />
                    </Suspense>
                </ChunkErrorBoundary>
            </>
        </div>
    );
};

export default RegistrationLayout;